import ContentAvatar from "@src/features/contentLibrary/ContentAvatar";
import Spinner from "@src/lib/ui/Spinner";
import { FC } from "react";
import ArrowUpRightIcon from "@src/lib/icons/18px/arrow-up-right";
import { toSafeHref } from "@src/features/libraryItem/course/UnfurledMedia";

type Props = {
  url?: string;
  isUploading?: boolean;
};

/**
 * The added file or link as a thumbnail that opens it. The "open" affordance
 * shows on hover rather than sitting on top of the thumbnail.
 */
export const MediaPreview: FC<Props> = ({ url, isUploading = false }) => {
  if (!url || isUploading) {
    return (
      <div className="flex size-14 shrink-0 items-center justify-center rounded-lg bg-bg-tertiary">
        <Spinner size={24} />
      </div>
    );
  }
  return (
    <button
      type="button"
      aria-label="Open in a new tab"
      className="group relative size-14 shrink-0 overflow-hidden rounded-lg focus-visible:ring-[3px] focus-visible:ring-brand-border focus-visible:outline-none"
      onClick={() => {
        // Only web links open; a pasted javascript: URL never runs here.
        const href = toSafeHref(url);
        if (href) window.open(href, "_blank", "noopener,noreferrer");
      }}
    >
      <ContentAvatar
        coverImage={{ imageUrls: { original: url } }}
        size="56px"
        contentType="Resource"
        defaultBackgroundHashKey={url}
      />
      {/* Media hover overlay: the white arrow sits on arbitrary thumbnails,
          so it needs more contrast than the 24% modal scrim (overlay-scrim). */}
      <span className="absolute inset-0 z-[3] flex items-center justify-center bg-black/45 text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100">
        <ArrowUpRightIcon className="size-4" />
      </span>
    </button>
  );
};
